import * as R from "ramda";
import { toast } from "react-toastify";
import * as ActionTypes from "../../constants/actiontypes/services";
import * as ActionTypesConfig from "../../constants/actiontypes/backoffice/configuration";
import * as Loadings from "../../constants/loadings/service";
import * as LoadingsConfig from "../../constants/loadings/backoffice/configuration";

import * as TextConfig from "../../constants/toasterText/backofficeConfig";
import * as TextService from "../../constants/toasterText/services";

const toastConf = { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 };

const ConfigurationReducer = (
	state = {
		isLoading: [],
		services: undefined,
		prices: undefined,
		serviceType: "",
		totalPages: 0,
		totalRecords: 0,
		currentPage: 0,
	},
	action
) => {
	switch (action.type) {
		case ActionTypes.FETCH_SERVICES_REQUEST:
			if (!state.isLoading.includes(Loadings.FETCHING_SERVICES)) {
				state.isLoading = state.isLoading.concat(Loadings.FETCHING_SERVICES);
			}

			return { ...state };

		case ActionTypes.FETCH_SERVICES_SUCCESS:
			// if (action.data.length < 100) {
			//     state.nextPage = false;
			// } else {
			//     state.nextPage = true;
			// }

			// let allBranches = [];
			// action.data.forEach(d => {
			//     if (d.branches.length > 0) {
			//         const branche = d.branches.forEach(b => {
			//             allBranches.push({ ...d, branches: b, address: b.address.addressLocality, branchName: b.name });
			//         });

			//     }
			// });

			state.isLoading = state.isLoading.filter((l) => l !== Loadings.FETCHING_SERVICES);
			state.services = action.data.items.map((s) => {
				s.streetAddress = s.address.streetAddress;
				return s;
			});
			state.serviceType = action.serviceType;

			state.totalPages = action.data.totalPages;
			state.totalRecords = action.data.totalRecords;
			state.currentPage = action.data.pageNumber + 1;
			return { ...state };

		case ActionTypes.FETCH_SERVICES_FAILURE:
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.FETCHING_SERVICES);
			state.services = [];
			return { ...state };

		case ActionTypes.CREATE_SERVICES_REQUEST:
			if (!state.isLoading.includes(Loadings.CREATING_SERVICE)) {
				state.isLoading = state.isLoading.concat(Loadings.CREATING_SERVICE);
			}

			return { ...state };

		case ActionTypes.CREATE_SERVICES_SUCCESS:
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.CREATING_SERVICE);
			let newService = { ...action.data };
			newService.streetAddress = newService.address.streetAddress;
			if (action.serviceType === state.serviceType) {
				state.services = [...state.services, newService];
			}
			toast.success(TextService.addedSuccessfully, toastConf);
			return { ...state };

		case ActionTypes.CREATE_SERVICES_FAILURE:
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.CREATING_SERVICE);
			toast.error(TextService.tryAddAgain, toastConf);
			return { ...state };

		case ActionTypes.UPDATE_SERVICES_REQUEST:
			if (!state.isLoading.includes(Loadings.UPDATING_SERVICE)) {
				state.isLoading = state.isLoading.concat(Loadings.UPDATING_SERVICE);
			}

			return { ...state };

		case ActionTypes.UPDATE_SERVICES_SUCCESS:
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.UPDATING_SERVICE);
			state.services = state.services.map((s) => {
				if (s.id === action.data.id) {
					return action.data;
				}
				return s;
			});

			if (action.serviceType !== state.serviceType) {
				state.services = state.services.filter((s) => s.id !== action.data.id);
			}

			toast.success(TextService.updatedSuccessfully, toastConf);
			return { ...state };

		case ActionTypes.UPDATE_SERVICES_FAILURE:
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.UPDATING_SERVICE);
			toast.error(TextService.tryUpdateAgain, toastConf);
			return { ...state };

		case ActionTypes.DELETE_SERVICE_BY_ID_REQUEST:
			if (!state.isLoading.includes(Loadings.DELETING_SERVICE)) {
				state.isLoading = state.isLoading.concat(Loadings.DELETING_SERVICE);
			}

			return { ...state };

		case ActionTypes.DELETE_SERVICE_BY_ID_SUCCESS:
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.DELETING_SERVICE);
			state.services = state.services.map((s) => {
				if (s.id === action.data.id) {
					return action.data;
				}
				return s;
			});

			if (action.service?.serviceType !== state.serviceType) {
				state.services = state.services.filter((s) => s.id !== action.service.id);
			}

			toast.success(TextService.deletedSuccessfully, toastConf);
			return { ...state };

		case ActionTypes.DELETE_SERVICE_BY_ID_FAILURE:
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.DELETING_SERVICE);
			toast.error(TextService.tryDeleteAgain, toastConf);
			return { ...state };

		case ActionTypes.RESET_SERVICES:
			state.services = [];
			state.serviceType = "";
			state.totalPages = 0;
			state.totalRecords = 0;
			state.currentPage = 0;
			return { ...state };

		case ActionTypesConfig.CREATE_POSTAL_NUMBER_REQUEST:
			if (!state.isLoading.includes(LoadingsConfig.CREATING_POSTAL_NUMBER)) {
				state.isLoading = state.isLoading.concat(LoadingsConfig.CREATING_POSTAL_NUMBER);
			}

			return { ...state };

		case ActionTypesConfig.CREATE_POSTAL_NUMBER_SUCCESS:
			state.isLoading = state.isLoading.filter((l) => l !== LoadingsConfig.CREATING_POSTAL_NUMBER);
			toast.success(TextConfig.addedSuccessfully, toastConf);
			return { ...state };

		case ActionTypesConfig.CREATE_POSTAL_NUMBER_FAILURE:
			state.isLoading = state.isLoading.filter((l) => l !== LoadingsConfig.CREATING_POSTAL_NUMBER);
			toast.error(TextConfig.tryAddAgain, toastConf);
			return { ...state };

		case ActionTypesConfig.FETCH_PRICE_REQUEST:
			if (!state.isLoading.includes(LoadingsConfig.FETCHING_PRICES)) {
				state.isLoading = state.isLoading.concat(LoadingsConfig.FETCHING_PRICES);
			}
			return { ...state };

		case ActionTypesConfig.FETCH_PRICE_SUCCESS:
			state.isLoading = state.isLoading.filter((l) => l !== LoadingsConfig.FETCHING_PRICES);
			state.prices = action.data.reduce((acc, product) => {
				acc[product.product.toLowerCase()] = product;
				return acc;
			}, {});
			return { ...state };

		case ActionTypesConfig.FETCH_PRICE_FAILURE:
			state.isLoading = state.isLoading.filter((l) => l !== LoadingsConfig.FETCHING_PRICES);
			return { ...state };

		case ActionTypesConfig.UPDATE_PRICE_REQUEST:
			if (!state.isLoading.includes(LoadingsConfig.UPDATING_PRICES)) {
				state.isLoading = state.isLoading.concat(LoadingsConfig.UPDATING_PRICES);
			}
			return { ...state };

		case ActionTypesConfig.UPDATE_PRICE_SUCCESS:
			state.isLoading = state.isLoading.filter((l) => l !== LoadingsConfig.UPDATING_PRICES);
			const newPrices = { ...state.prices };
			newPrices[action.data.product.toLowerCase()] = action.data;
			state.prices = { ...newPrices };
			toast.success(TextConfig.updatedSuccessfully, toastConf);
			return { ...state };

		case ActionTypesConfig.UPDATE_PRICE_FAILURE:
			state.isLoading = state.isLoading.filter((l) => l !== LoadingsConfig.UPDATING_PRICES);
			toast.error(TextConfig.tryUpdateAgain, toastConf);
			return { ...state };

		default:
			return state;
	}
};
export default ConfigurationReducer;
